// File: /Users/alex/PilotMode/GlobalCommand-Center/FrontStack/src/Pages/LandingPage/data.js

import BuildIcon from "@mui/icons-material/Build";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import WorkIcon from "@mui/icons-material/Work";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import PeopleIcon from "@mui/icons-material/People";
import BarChartIcon from "@mui/icons-material/BarChart";
import GavelIcon from "@mui/icons-material/Gavel";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import GroupIcon from "@mui/icons-material/Group";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

export const departments = [
  { 
    name: "Product & Technology", 
    icon: <BuildIcon />, 
    description: "Driving innovation through cutting-edge technology and user-centric product development.",
    metrics: {
      projects: 24,
      teamSize: 47,
      growthRate: 18.5,
      completion: 87
    }
  },
  { 
    name: "Marketing & Growth", 
    icon: <TrendingUpIcon />, 
    description: "Creating compelling campaigns and strategies to drive business growth and brand awareness.",
    metrics: {
      campaigns: 38,
      teamSize: 32,
      growthRate: 24.7,
      conversion: 8.2
    }
  },
  { 
    name: "Sales & Business Dev", 
    icon: <WorkIcon />, 
    description: "Expanding market reach and building valuable relationships with clients and partners.",
    metrics: {
      deals: 156,
      teamSize: 28,
      growthRate: 15.3,
      target: 92
    }
  },
  { 
    name: "Customer Success", 
    icon: <SupportAgentIcon />, 
    description: "Ensuring exceptional customer experiences through responsive support and personalized solutions.",
    metrics: {
      tickets: 842,
      teamSize: 35,
      growthRate: 12.8,
      satisfaction: 94
    }
  },
  { 
    name: "Operations", 
    icon: <PeopleIcon />, 
    description: "Optimizing processes and workflows to ensure efficient and effective business operations.",
    metrics: {
      processes: 64,
      teamSize: 26,
      growthRate: 9.4,
      efficiency: 89
    }
  },
  { 
    name: "Data & Analytics", 
    icon: <BarChartIcon />, 
    description: "Transforming raw data into actionable insights to drive strategic business decisions.",
    metrics: {
      reports: 215,
      teamSize: 22,
      growthRate: 21.6,
      accuracy: 96
    }
  },
  { 
    name: "Legal & Compliance", 
    icon: <GavelIcon />, 
    description: "Ensuring regulatory compliance and providing sound legal counsel to minimize business risks.",
    metrics: {
      reviews: 124,
      teamSize: 18,
      growthRate: 7.2,
      compliance: 99
    }
  },
  { 
    name: "Finance", 
    icon: <AccountBalanceIcon />, 
    description: "Managing financial resources and planning for sustainable growth and profitability.",
    metrics: {
      transactions: 3426,
      teamSize: 24,
      growthRate: 11.7,
      accuracy: 99.8
    }
  },
  { 
    name: "Human Resources", 
    icon: <GroupIcon />, 
    description: "Attracting, developing, and retaining top talent to build a high-performing organization.",
    metrics: {
      employees: 325,
      openings: 17,
      growthRate: 14.3,
      retention: 91
    }
  },
];

export const stats = [
  { label: "Active Tasks", value: "1,247", icon: <AssignmentIcon />, color: "#6366f1" },
  { label: "Team Members", value: "325", icon: <GroupIcon />, color: "#10b981" },
  { label: "Completion Rate", value: "94%", icon: <CheckCircleOutlineIcon />, color: "#f59e0b" },
  { label: "Avg Response", value: "2.3h", icon: <AccessTimeIcon />, color: "#ec4899" },
];

export const features = [
  {
    icon: <TaskAltIcon sx={{ fontSize: 40 }} />,
    title: "Smart Task Management",
    description: "AI-powered task prioritization and intelligent assignment",
    color: "#6366f1"
  },
  {
    icon: <GroupIcon sx={{ fontSize: 40 }} />,
    title: "Team Collaboration",
    description: "Real-time collaboration with seamless communication",
    color: "#10b981"
  },
  {
    icon: <TrendingUpIcon sx={{ fontSize: 40 }} />,
    title: "Performance Analytics",
    description: "Insightful dashboards to track progress and productivity",
    color: "#f59e0b"
  },
  {
    icon: <RocketLaunchIcon sx={{ fontSize: 40 }} />,
    title: "Workflow Automation",
    description: "Automate repetitive tasks and streamline processes",
    color: "#ec4899"
  },
];

export const getChartData = (departments) => ({
  growthChartData: {
    labels: departments.map(dept => dept.name),
    datasets: [
      {
        label: 'Growth Rate (%)',
        data: departments.map(dept => dept.metrics.growthRate),
        backgroundColor: '#228B22',
        borderColor: '#1e7a1e',
        borderWidth: 1,
      },
    ],
  },
  metricsComparisonData: {
    labels: ['Q1', 'Q2', 'Q3', 'Q4'],
    datasets: [
      {
        label: 'Product & Technology',
        data: [65, 72, 78, 87],
        borderColor: '#4caf50',
        backgroundColor: 'rgba(76, 175, 80, 0.2)',
        tension: 0.4,
      },
      {
        label: 'Marketing & Growth',
        data: [58, 69, 75, 82],
        borderColor: '#2196f3',
        backgroundColor: 'rgba(33, 150, 243, 0.2)',
        tension: 0.4,
      },
      {
        label: 'Sales & Business Dev',
        data: [70, 75, 82, 92],
        borderColor: '#ff9800',
        backgroundColor: 'rgba(255, 152, 0, 0.2)',
        tension: 0.4,
      },
      {
        label: 'Customer Success',
        data: [75, 80, 87, 94],
        borderColor: '#9c27b0',
        backgroundColor: 'rgba(156, 39, 176, 0.2)',
        tension: 0.4,
      },
    ],
  }
});

export const chartOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: 'Department Growth Rate (%)',
      font: {
        size: 16,
        weight: 'bold',
      },
    },
  },
};

export const lineChartOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: 'Quarterly Performance By Department',
      font: {
        size: 16,
        weight: 'bold',
      },
    },
  },
};